import type { FullScreenLegendSeries } from '../fullScreenChartTypes';

export const LEGEND_COLUMNS = [
  { key: 'visible', label: 'Visible' },
  { key: 'series', label: 'Series' },
  { align: 'right', key: 'value', label: 'Value' }
] as const;

export const getLegendSeriesDescription = (item: FullScreenLegendSeries): string =>
  [item.code, item.period, item.timeRef].filter(Boolean).join(' · ') ||
  'Series details unavailable';

export const getLegendValue = (item: FullScreenLegendSeries): string =>
  [item.value, item.units].filter(Boolean).join(' ');
